export enum ContentType {
  Image = 'image',
  Html = 'html',
  Css = 'css'
}

export interface ContentItem {
  type: ContentType;
  href?: string;
  content?: string;
  alt?: string;
}